import {Component, Input, OnInit} from '@angular/core';

import {map} from 'rxjs/operators';

import {Model} from '../../model/model';
import {ObjectList} from '../../model/object-list';

@Component({
  selector: 'app-text-list-filter',
  templateUrl: './text-list-filter.component.html',
  styleUrls: ['./text-list-filter.component.scss']
})
export class TextListFilterComponent implements OnInit {

  @Input() public list: ObjectList<Model>;
  @Input() filter = 'text';

  data$;

  constructor() {
  }

  set(value: string) {
    this.list.setFilter(this.filter, value, '*');
  }

  ngOnInit() {
    this.data$ = this.list.filters$.pipe(
      map((filters) => {
        return {
          text: filters[this.filter]?.value
        };
      })
    );
  }
}
